import commonUtils from '../../../utils/commonUtils';
import { moment } from '../../../utils/momentUtils';

class RangePickerHelper {
  // 设置时间
  startPicker;
  endPicker;
  // ref引用
  startPickerRef;
  endPickerRef;
  // 显示的时间类型
  picker: 'date' | 'month' | 'year';
  // 显示是否以当前的时间为准
  isMoreToday?: boolean = false;
  // 设置可显示的时间范围
  disabledStartDate: any = null;
  disabledEndDate: any = null;

  init(props: any, isMoreToday?: boolean) {
    const { startDefaultValue, startValue, endDefaultValue, endValue, picker = 'date', disabledStartDate, disabledEndDate } = props;
    if (!commonUtils.isUndefined(isMoreToday)) {
      this.isMoreToday = isMoreToday;
    }

    const startDates = startDefaultValue || startValue || undefined;
    this.startPicker = typeof startDates === 'string' ? moment(startDates) : startDates;

    const endDates = endDefaultValue || endValue || undefined;
    this.endPicker = typeof endDates === 'string' ? moment(endDates) : endDates;

    this.picker = picker;
    this.disabledStartDate = disabledStartDate;
    this.disabledEndDate = disabledEndDate;
  }

  renderDisabledStart = startValue => {
    if (this.disabledStartDate) {
      return this.disabledStartDate(startValue);
    }
    if (!startValue || !this.endPicker) {
      return false;
    }
    const result = startValue.valueOf() > this.endPicker.valueOf();
    if (!this.isMoreToday) {
      return result;
    }
    return (startValue && startValue > moment().endOf(this.picker)) || result;
  };

  renderDisabledEnd = endValue => {
    if (this.disabledEndDate) {
      return this.disabledEndDate(endValue);
    }
    if (!endValue || !this.startPicker) {
      return false;
    }
    const result = endValue.valueOf() < this.startPicker.valueOf();
    if (!this.isMoreToday) {
      return result;
    }
    return (endValue && endValue > moment().endOf(this.picker)) || result;
  };

  onStartChange = (date, dateString, onChange) => {
    this.startPicker = date;
    if (onChange) {
      onChange(date, dateString);
    }
  };

  onEndChange = (date, dateString, onChange) => {
    this.endPicker = date;
    if (onChange) {
      onChange(date, dateString);
    }
  };

  validatorOneValue = ref => {
    return ref ? ref.validatorValue() : {};
  };

  validatorValue() {
    const { pass: pass1, msg: msg1 } = this.validatorOneValue(this.startPickerRef);
    const { pass: pass2, msg: msg2 } = this.validatorOneValue(this.endPickerRef);
    const result = {
      pass: pass1 && pass2,
      msg: msg1 || msg2
    };
    return result;
  }

  reset(props: any) {
    const { startDefaultValue, startValue, endDefaultValue, endValue } = props;
    if (this.startPickerRef) {
      const startDates = startDefaultValue || startValue || undefined;
      this.startPicker = typeof startDates === 'string' ? moment(startDates) : startDates;
      this.startPickerRef.reset();
    }
    if (this.endPickerRef) {
      const endDates = endDefaultValue || endValue || undefined;
      this.endPicker = typeof endDates === 'string' ? moment(endDates) : endDates;
      this.endPickerRef.reset();
    }
  }

  resetResult() {
    if (this.startPickerRef) {
      this.startPickerRef.resetResult();
    }
    if (this.endPickerRef) {
      this.endPickerRef.resetResult();
    }
  }

  getValue() {
    return {
      start: this.startPickerRef ? this.startPickerRef.getValue() : '',
      end: this.endPickerRef ? this.endPickerRef.getValue() : ''
    };
  }
}

export default RangePickerHelper;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/helper/rangePickerHelper.ts